import { createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchCars, updateCar, deleteCar, addCar } from '../actions';
import { Car } from '../types';

interface CarState {
  items: Car[];
  loading: boolean;
  error: string | null;
}

const initialState: CarState = {
  items: [],
  loading: false,
  error: null,
};

const carSlice = createSlice({
  name: 'cars',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<CarState>) => {
    // Fetch Cars
    builder.addCase(fetchCars.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCars.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload;
    });
    builder.addCase(fetchCars.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || 'An error occurred';
    });

    // Update Car
    builder.addCase(updateCar.fulfilled, (state, action) => {
      const index = state.items.findIndex((car) => car.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    });

    // Delete Car
    builder.addCase(deleteCar.fulfilled, (state, action) => {
      state.items = state.items.filter((car) => car.id !== action.payload);
    });

    // Add Car
    builder.addCase(addCar.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(addCar.fulfilled, (state, action) => {
      state.loading = false;
      state.items.push(action.payload);
    });
    builder.addCase(addCar.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
  },
});

export default carSlice.reducer;
